import { render, staticRenderFns } from "./UsageInfo.vue?vue&type=template&id=89960888&scoped=true"
import script from "./UsageInfo.vue?vue&type=script&lang=js"
export * from "./UsageInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89960888",
  null
  
)

export default component.exports